import { computed } from 'vue';
import { useKradInputStore } from '@/features/Sparten/krad/useInputStore';
import { WKZ } from '@/features/Sparten/shared/types/kfz/types';

export const isWkz003 = computed(
  (): boolean =>
    useKradInputStore().allgemein !== undefined &&
    useKradInputStore().allgemein.wkz === WKZ.KRAFTRAEDER_KRAFTROLLER,
);
